function subOneMonthDate(date) {
  date.setMonth(date.getMonth() - 1)
  return date
}

const getMinDate = () => {
  const date = new Date()
  if (date.getDate() <= 5) return subOneMonthDate(date)
  return date
}

export default getMinDate
